<template>
  <div class="mb-3">
    <label :for="id"
      >{{ label }} <span v-if="required" class="text-danger">*</span></label
    >
    <vee-field
      :id="id"
      :name="name"
      :rules="validationRules"
      v-slot="{ field, meta }"
    >
      <input
        v-bind="field"
        :id="id"
        type="number"
        :placeholder="placeholder"
        :class="[
          'form-control',
          { 'is-invalid': meta.touched && !meta.valid },
          { 'is-valid': meta.touched && meta.valid },
        ]"
        @keypress="onKeyPress"
        @input="onInput"
        @paste="onPaste"
      />
    </vee-field>
    <ErrorMessage class="text-danger" :name="name" />
  </div>
</template>

<script setup>
const onKeyPress = (event) => {
  const char = String.fromCharCode(event.which);
  const inputValue = event.target.value;

  if (/[0-9]/.test(char)) {
    return true;
  }

  if (char === "." && !inputValue.includes(".")) {
    return true;
  }

  if (char === "-" && inputValue.length === 0) {
    return true;
  }

  event.preventDefault();
  return false;
};

const onInput = (event) => {
  let value = event.target.value;

  value = value.replace(/[^0-9.-]/g, "");

  const parts = value.split(".");
  if (parts.length > 2) {
    value = parts[0] + "." + parts.slice(1).join("");
  }

  if (value.indexOf("-") > 0) {
    value = value.replace(/(-)/g, "");
  }

  if (event.target.value !== value) {
    event.target.value = value;
    event.target.dispatchEvent(new Event("input", { bubbles: true }));
  }
};

const onPaste = (event) => {
  setTimeout(() => {
    let value = event.target.value;
    const originalValue = value;

    value = value.replace(/[^0-9.-]/g, "");

    const parts = value.split(".");
    if (parts.length > 2) {
      value = parts[0] + "." + parts.slice(1).join("");
    }

    if (value.indexOf("-") > 0) {
      value = value.replace(/(-)/g, "");
    }

    if (originalValue !== value) {
      event.target.value = value;
      event.target.dispatchEvent(new Event("input", { bubbles: true }));
    }
  }, 0);
};

defineProps({
  id: {
    type: String,
    required: true,
  },
  name: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
  required: {
    type: Boolean,
    default: false,
  },
  placeholder: {
    type: String,
    default: "",
  },
  fieldName: {
    type: String,
    default: "",
  },
  validationRules: {
    type: [Function, Array, String, Object],
    default: () => () => true,
  },
});
</script>
